import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M14.784 14.813H5.625V5.625h9.16zm0 13.782H5.625v-9.188h9.16zm0 13.781H5.625v-9.188h9.16zM28.58 14.813h-9.159V5.625h9.159zm0 13.782h-9.159v-9.188h9.159zm0 13.781h-9.159v-9.188h9.159zm4.636-36.751h9.159v9.188h-9.159zm0 13.781h9.159v9.188h-9.159zm0 13.782h9.159v9.188h-9.159z" }) }) })
});
export default SvgViewSmall;
